import { createSelector } from 'reselect'
import { RootStoreState } from '@src/models/app.types'

export const educationStoreStateSelector = (state: RootStoreState) => state.education

export const visitedTutorialsSelector = createSelector(
  educationStoreStateSelector,
  (store) => store.visitedTutorials,
)
